/**
 * Shared book identity (#700 / #705).
 *
 * One book object lives in projects.arc_structure (Timeline).
 * Series Notes reads those same objects — same id — as pile cards.
 * Compact pin on the rail; title + what this book is about in the pile.
 * Do not copy titles into series_snapshots. Do not invent a third store.
 * The store field stays `proposition`. Writer-facing copy is the logline
 * ask, not a thesis. Existing stored text is the writer's words.
 * Start this book is still the only way to make a real book.
 * Moving a pin still writes the board only.
 */

import {
  bookItems,
  itemsFromBoard,
  markCardStarted,
} from './seriesBookBoard';

import { BOOKS_IN_NOTES_LEDE } from './writerCopy';

export const BOOKS_IN_PILE_LEDE = BOOKS_IN_NOTES_LEDE;

export const NO_TIMELINE_BOOKS = 'No books on the Timeline yet.';

export const BOOK_LINE_LABEL = 'What this book is about';

export const BOOK_LINE_EMPTY = 'What this book is about.';

export const BOOK_LINE_PLACEHOLDER =
  'A short note of the story — who, what, and the situation.';

export function sharedBooksFromBoard(board) {
  return bookItems(itemsFromBoard(board));
}

export function patchSharedBook(items, bookId, fields) {
  return (items || []).map((item) => {
    if (item.id !== bookId || (item.type || 'book') !== 'book') return item;
    const next = { ...item, type: 'book', ...fields };
    if (next.status === 'idea') next.story_id = null;
    return next;
  });
}

export function startSharedBook(items, bookId, storyId) {
  return markCardStarted(items, bookId, storyId);
}

export function bookStatusLabel(book) {
  return book?.status === 'started' ? 'Started' : 'Idea only';
}
